import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { FreeTrialPage } from './pages/FreeTrialPage';
import { PricingPage } from './pages/PricingPage';
import { LoginPage } from './pages/LoginPage';
import { ContactPage } from './pages/ContactPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-32">
      <Routes data-id="element-33">
        <Route path="/" element={<App data-id="element-35" />} data-id="element-34" />
        <Route path="/trial" element={<FreeTrialPage data-id="element-37" />} data-id="element-36" />
        <Route path="/pricing" element={<PricingPage data-id="element-39" />} data-id="element-38" />
        <Route path="/login" element={<LoginPage data-id="element-41" />} data-id="element-40" />
        <Route path="/contact" element={<ContactPage data-id="element-43" />} data-id="element-42" />
        <Route path="/terms-and-conditions" element={<TermsPage data-id="element-45" />} data-id="element-44" />
        <Route path="/privacy-policy" element={<PrivacyPage data-id="element-47" />} data-id="element-46" />
      </Routes>
    </BrowserRouter>;
}